const getCookieValue = (key: string) => document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`)?.pop() ?? '';

export default getCookieValue;
